import { create } from 'zustand'
import { EnergyLevelListing } from 'types/listing/listings'

const energyLevelCreationStore = (set: any) => ({
  energyLevelModal: false,
  setEnergyLevelModal: (state: boolean) =>
    set(() => ({ energyLevelModal: state })),
  energyLevelData: null,
  setEnergyLevelData: (state: EnergyLevelListing) =>
    set(() => ({ energyLevelData: state })),
})

export const energyLevelStore = create(energyLevelCreationStore)
